import * as types from '../mutations'
import Vue from 'vue'

const services = {
  group: window.abp.services.app.group,
  ajax: window.abp.ajax
}

// initial state
const state = {
  all: [],
  pagination: {},
  activeGroup: {},
  allDataTypes: []
}

// getters
const getters = {
  allGroups: state => state.all,
  allGroupsPagination: state => state.pagination,
  activeGroup: state => state.activeGroup,
  allDataTypes: state => state.allDataTypes
}

// actions
const actions = {
  getAllGroups({ commit }, request) {
    if (!request) {
      request = {}
    }
    return new Promise((resolve, reject) => {
      services.group.getList(request).done(function (response) {
        let groups = response.items
        let pagination = {
          currentPage: response.currentPage,
          totalCount: response.totalCount,
          totalPage: response.totalPage
        }
        commit(types.DATA.RECEIVE_GROUPS, { groups, pagination })
        resolve()
      })
    })
  },
  getGroup({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      services.group.get(request).done(function (response) {
        commit(types.DATA.UPDATE_ACTIVE_GROUP, response)
        resolve()
      })
    })
  },
  createOrUpdateGroup({ commit }, group) {
    return new Promise((resolve, reject) => {
      let action = group.id !== '' ? services.group.update(group) : services.group.create(group)
      action
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_GROUP, response)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject()
        })
    })
  },
  deleteGroup({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.group.delete({ id: id })
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_GROUP, null)
          resolve()
        })
    })
  },
  setPaymentOptions({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.group.setPaymentOptions(request)
        .done(function (response) {
          commit(types.DATA.UPDATE_ACTIVE_GROUP, response)
          resolve()
        })
    })
  },
  getDataTypes({ commit }) {
    return new Promise((resolve, reject) => {
      services.group.getDataTypes().done(function (response) {
        commit(types.DATA.RECEIVE_DATATYPES, response)
        resolve()
      })
    })
  },
  importMembers({ commit }, request) {
    let endpoint = Vue.$config('endpoint')
    let url = `${endpoint}/settings/import-export/import?groupImport=${request.get('groupImport')}`
    return new Promise((resolve, reject) => {
      services.ajax({
        url: url,
        type: 'POST',
        data: request,
        processData: false,
        contentType: false
      })
        .done(function (response) {
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  proceedMembersImport({ commit }, id) {
    let endpoint = Vue.$config('endpoint')
    let url = `${endpoint}/settings/import-export/proceed-import?groupId=${id}`
    return new Promise((resolve, reject) => {
      services.ajax({url: url, type: 'GET'})
        .done(function (response) {
          resolve()
        })
        .fail(function (response) {
          reject()
        })
    })
  }
}

// mutations
const mutations = {
  [types.DATA.RECEIVE_GROUPS](state, { groups, pagination }) {
    state.all = groups
    state.pagination = pagination
  },
  [types.DATA.UPDATE_ACTIVE_GROUP](state, group) {
    state.activeGroup = group
  },
  [types.DATA.RECEIVE_DATATYPES](state, dataTypes) {
    state.allDataTypes = dataTypes
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/modules/groups.js